import { detectClient, devices } from '@nykaa/utils/device';
/*
  This function returns true for Web otherwise False
*/
export const isDeviceTypeWeb = () => {
    let status = false;
    try {
        // skip in the case of SSR, return false as in client UseEffect
        if (typeof window === 'undefined') {
            return false;
        }
        const client = detectClient(window.navigator.userAgent);
        if (client.device === devices.WEB)
            status = true;
    }
    catch (error) {
        status = false;
    }
    return status;
};
/*
  For Web Platform, Story widget uses
  webResources -> {html,jsScript} otherwise use appResources -> {appWebviewHtml,appWebviewJsScript}
  field from Backend
*/
export const getResourceForStoryWidget = (webResource, appResource) => {
    if (!isDeviceTypeWeb()) {
        return appResource;
    }
    return webResource;
};
/*
  Encoding JS Script
  ------------------
  <script> -> %%%script%%%>
  </script> -> </&&&script&&&
  <script src={}> -> %%%script%%% src={}>

  Decoding JS
  -----------
  Decoding JS Script
  %%%script%%%>-> <script>
  </&&&script&&& -> </script>
  %%%script%%% src={}> -> <script src={}>

  Note :- Encoding | Decoding Sequence Needs to be followed to avoid string corruption
*/
export const decodeJSScriptString = (jsScript) => {
    let finalScript = jsScript;
    try {
        // if empty string then return ''
        if (!finalScript)
            return '';
        finalScript = jsScript.replace(/%%%script%%%/g, '<script');
        finalScript = finalScript.replace(/&&&script&&&/g, 'script>');
    }
    catch (error) {
        finalScript = '';
    }
    return finalScript;
};
